import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import SiteTitle from "../../../../helpers/SiteTitle/SiteTitle";
import ValidationErrorMessage from "../../../../helpers/ValidationErrorMessage/ValidationErrorMessage";
import { areYouSureMessage } from "../../../../utils/toastMessage/toastMessage";
import {
  addNewsAdminValidation,
  editNewsAdminValidation,
} from "../../../../utils/validation/validation";

import {
  HiNewspaper,
  HiOutlinePlusSm,
  HiOutlineX,
  HiLockOpen,
  HiLockClosed,
} from "react-icons/hi";
import { FaRobot, FaPowerOff } from "react-icons/fa";

import { newsAdminContext } from "../../../../context/AdminContext/NewsAdminContext/NewsAdminContext";

const AdminDashboardNews = () => {
  const userInfo = useSelector((state) => state.userInfo);

  const {
    isOpenAddModal,
    setIsOpenAddModal,
    getNewsItems,
    editNewsId,
    newsInfoData,
    setAdminUser,
    handleCreateNewsAdmin,
    handleGetNewsAdmin,
    handleEditNewsAdmin,
    handleCloseEditModal,
    handleOpenEditModal,
    handleDeleteNews,
    handleChangeStoreStatus,
    handleGetStoreStatus,
    isStoreCloses,
    handleChangeAutoPilot,
    handleGetAutoPilot,
    isAutoPilot,
    setIsAutoPilot,
  } = useContext(newsAdminContext);

  useEffect(() => {
    handleGetNewsAdmin();
  }, []);

  useEffect(() => {
    handleGetStoreStatus();
  }, []);
  useEffect(() => {
    handleGetAutoPilot();
  }, []);
  console.log("isAutoPilot:", isAutoPilot);
  console.log("isStoreCloses:", isStoreCloses);
  // Add New Validation
  const {
    register: registerAddNews,
    handleSubmit: handleSubmitAddNews,
    reset,
    formState: { errors: errorsAddNews },
  } = useForm({
    resolver: yupResolver(addNewsAdminValidation),
  });

  // Edit News Validation
  const {
    register: registerEditNews,
    handleSubmit: handleSubmitEditNews,
    setValue,
    formState: { errors: errorsEditNews },
  } = useForm({
    resolver: yupResolver(editNewsAdminValidation),
  });

  return (
    <>
      <SiteTitle title="اخبار" />
      <div className="mr-auto 2xl:w-[85%] xl:w-[75%] lg:w-[70%] w-full h-full mb-16">
        <div className="flex h-screen justify-center items-center rounded-xl ">
          <div
            className="rounded-xl flex flex-col h-full w-full relative
             animate__animated animate__fadeIn animate__fast"
          >
            {/* Table */}
            <div className="w-full flex-col mt-10">
              {/* Add Product Button */}
              <span className="bg-green-500 hover:bg-green-600 rounded-full text-white float-left ml-2">
                <button
                  onClick={() => {
                    reset();
                    setIsOpenAddModal(true);
                  }}
                  className="flex items-center px-2 lg:py-2 py-1 font-bold lg:text-sm text-xs tracking-wide"
                >
                  اضافه کردن اخبار
                  <HiOutlinePlusSm size={20} />
                </button>
              </span>

              {/* Store Status and Autopilot Buttons - Centered */}
              <div className="flex justify-center items-center -mt-6 mb-10 space-x-4">
                {/* Store Status Button */}
                {isStoreCloses === true && (
                  <span
                    onClick={() => handleChangeStoreStatus(false)}
                    className="cursor-pointer p-3 rounded-full bg-red-100 hover:bg-red-200 transition"
                    title="فعال کردن فروشگاه"
                  >
                    <HiLockClosed size={30} fill="#dc2626" />
                  </span>
                )}
                {isStoreCloses === false && (
                  <span
                    onClick={() => handleChangeStoreStatus(true)}
                    className="cursor-pointer p-3 rounded-full bg-green-100 hover:bg-green-200 transition"
                    title="غیرفعال کردن فروشگاه"
                  >
                    <HiLockOpen size={30} fill="#16a34a" />
                  </span>
                )}

                {/* Autopilot Button
                {isAutoPilot === true && (
                  <span
                    onClick={() => handleChangeAutoPilot(false)}
                    className="cursor-pointer p-3 rounded-full bg-green-100 mr-2 hover:bg-green-200 transition"
                    title="خاموش کردن اتوپایلوت"
                  >
                    <FaRobot size={30} fill="#16a34a" />
                  </span>
                )}
                {isAutoPilot === false && (
                  <span
                    onClick={() => handleChangeAutoPilot(true)}
                    className="cursor-pointer p-3 rounded-full bg-red-100 mr-2 hover:bg-red-200 transition"
                    title="روشن کردن اتوپایلوت"
                  >
                    <FaPowerOff size={30} fill="#dc2626" />
                  </span>
                )} */}
              </div>

              {isEmpty(getNewsItems) ? (
                <>
                  <span
                    className="mr-auto w-full py-3 mt-10
                    text-gray-300 text-xl flex flex-col
                     justify-center items-center absolute top-[50%]"
                  >
                    <span>
                      <HiNewspaper size={60} className="mb-2" />
                    </span>
                    <p>اخباری وجود ندارد</p>
                  </span>
                </>
              ) : (
                <>
                  <table className="w-full h-full">
                    <thead className="text-sm font-medium text-gray-300 border-b-[1px] border-[#A79B81]">
                      <tr>
                        <th className="py-3">
                          <div>موضوع اخبار</div>
                        </th>
                        <th className="py-3">
                          <div>متن اخبار</div>
                        </th>
                        <th className="py-3">
                          <div>عملیات</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-lg divide-y divide-gray-200 w-full h-full overflow-y-scroll">
                      {getNewsItems.map((_item) => (
                        <>
                          <tr
                            key={_item.id}
                            className="hover:bg-[#153477] w-full h-16 relative
                            text-center lg:text-sm text-xs font-medium tracking-wide text-gray-300"
                          >
                            {/* Title */}
                            <td>
                              <span>{_item.title}</span>
                            </td>
                            {/* Description */}
                            <td className="flex justify-center items-center h-full">
                              <span className="flex justify-center w-44">
                                <p className="truncate ... w-full">
                                  {_item.description}
                                </p>
                              </span>
                            </td>
                            {/* Buttons */}
                            <td>
                              <span
                                className="flex lg:flex-row-reverse flex-col 
                                 justify-center items-center text-gray-950 lg:text-sm
                                  text-xs font-bold lg:space-x-2 lg:space-y-0 space-y-2 space-x-0"
                              >
                                {/* Delete Button */}
                                <span>
                                  <button
                                    onClick={() =>
                                      areYouSureMessage(
                                        () => handleDeleteNews(_item.id),
                                        `آیا از حذف ${_item.title} مطمئنید؟`
                                      )
                                    }
                                    className="bg-red-600 hover:bg-red-700 text-white
                           tracking-wider lg:px-2.5 px-1.5 lg:py-1 py-0.5 rounded-full"
                                  >
                                    حذف
                                  </button>
                                </span>
                                {/* Edit Button */}
                                <span>
                                  <button
                                    onClick={() =>
                                      handleOpenEditModal(_item, setValue)
                                    }
                                    className="bg-yellow-500 hover:bg-yellow-600 text-white
                          tracking-wider lg:px-2.5 px-1.5 lg:py-1 py-0.5 rounded-full"
                                  >
                                    ویرایش
                                  </button>
                                </span>
                              </span>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>

            {/* Add Modal */}
            {isOpenAddModal && (
              <div
                className="fixed bg-black bg-opacity-40 inset-0
           w-full h-full z-50 flex items-center justify-center
           animate__animated animate__fadeIn animate__fast"
              >
                <div
                  className="flex bg-[#101632] flex-col absolute lg:top-20 top-10
             w-11/12 sm:w-5/6 lg:w-12/12 max-w-2xl mx-auto rounded-lg 
             border-2 border-gray-300"
                >
                  <div className="flex flex-row justify-between p-5 bg-[#101632]">
                    {/* Title - Close Icon */}
                    <span className="flex justify-between w-full">
                      {/* Title */}
                      <span>
                        <p className="font-semibold text-gray-300">
                          اضافه کردن اخبار
                        </p>
                      </span>
                      {/* Close Icon */}
                      <span>
                        <HiOutlineX
                          size={25}
                          onClick={() => setIsOpenAddModal(false)}
                          className="text-gray-300 cursor-pointer"
                        />
                      </span>
                    </span>
                  </div>
                  <span className="border-b-2 border-gray-300" />
                  {/* Inputs */}
                  <div className="w-full px-6 py-5 bg-[#101632]">
                    <form onSubmit={handleSubmitAddNews(handleCreateNewsAdmin)}>
                      <div className="flex flex-col w-full">
                        {/* Title */}
                        <span>
                          <label
                            htmlFor="title"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-300"
                          >
                            موضوع اخبار
                          </label>
                          <input
                            type="text"
                            name="title"
                            placeholder="موضوع اخبار"
                            autoComplete="off"
                            {...registerAddNews("title")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 
                                  w-full lg:text-base text-sm tracking-wide text-gray-300
                                  rounded-md focus:right-0 focus:outline-none
                                focus:border-black-400 focus:text-slate-700"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsAddNews.title?.message}
                            />
                          </span>
                        </span>
                        {/* Description */}
                        <span>
                          <label
                            htmlFor="description"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-300"
                          >
                            متن اخبار
                          </label>
                          <textarea
                            type="text"
                            name="description"
                            placeholder="متن اخبار"
                            autoComplete="off"
                            {...registerAddNews("description")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 
                                  w-full lg:text-base text-sm tracking-wide text-gray-300
                                  rounded-md focus:right-0 focus:outline-none
                                focus:border-black-400 focus:text-slate-700"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsAddNews.description?.message}
                            />
                          </span>
                        </span>
                        {/* User Id */}
                        <span>{setAdminUser(userInfo[0]?.id)}</span>
                      </div>
                      {/* Button */}
                      <div className="flex items-center justify-end p-5 w-full bg-[#101632]">
                        <button
                          type="submit"
                          className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                        >
                          اضافه کردن
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}

            {/* Edit Modal */}
            {editNewsId && (
              <div
                className="flex bg-[#101632] bg-opacity-40 fixed lg:mr-40
                inset-0 items-center w-full z-50 mr-auto h-screen
                animate__animated animate__fadeIn animate__fast"
              >
                <div
                  className="flex flex-col bg-[#101632] absolute top-20 left-0 right-0 
                  w-11/12 sm:w-5/6 lg:w-12/12 max-w-2xl mx-auto rounded-lg 
                  border-2 border-gray-300"
                >
                  <div className="flex flex-row bg-[#101632] justify-between p-5 bg-[#101632]">
                    {/* Title - Close Icon */}
                    <span className="flex justify-between w-full">
                      {/* Title */}
                      <span>
                        <p className="font-semibold text-gray-300">
                          ویرایش کردن اخبار
                          <span className="mx-2 font-bold text-gray-300">
                            {newsInfoData.title}
                          </span>
                        </p>
                      </span>
                      {/* Close Icon */}
                      <span>
                        <HiOutlineX
                          size={25}
                          onClick={handleCloseEditModal}
                          className="text-gray-300 cursor-pointer"
                        />
                      </span>
                    </span>
                  </div>
                  <span className="border-b-2 border-gray-300" />
                  {/* Inputs */}
                  <div className="w-full px-6 py-5 bg-[#101632]">
                    <form onSubmit={handleSubmitEditNews(handleEditNewsAdmin)}>
                      <div className="flex flex-col w-full">
                        {/* Title */}
                        <span>
                          <label
                            htmlFor="title"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-300"
                          >
                            موضوع اخبار
                          </label>
                          <input
                            type="text"
                            name="title"
                            placeholder="موضوع اخبار"
                            autoComplete="off"
                            {...registerEditNews("title")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 
                            w-full lg:text-base text-sm tracking-wide text-gray-300
                            rounded-md focus:right-0 focus:outline-none
                          focus:border-black-400 focus:text-slate-700"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsEditNews.title?.message}
                            />
                          </span>
                        </span>
                        {/* Description */}
                        <span>
                          <label
                            htmlFor="description"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-300"
                          >
                            متن اخبار
                          </label>
                          <textarea
                            type="text"
                            name="description"
                            placeholder="متن اخبار"
                            autoComplete="off"
                            {...registerEditNews("description")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 
                            w-full lg:text-base text-sm tracking-wide text-gray-300
                            rounded-md focus:right-0 focus:outline-none
                          focus:border-black-400 focus:text-slate-700"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsEditNews.description?.message}
                            />
                          </span>
                        </span>
                      </div>
                      {/* Button */}
                      <div className="flex items-center justify-end p-5 w-full bg-[#101632]">
                        <button
                          type="submit"
                          className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                        >
                          ویرایش کردن
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboardNews;
